import React, { useContext } from 'react';
import { Card, Box } from '@mui/material';
import TermsAndCondition from 'Components/Doc/TermsAndCondition/index';
import { AppContext } from 'Context';
import { V2SettingsShell } from '../../_shared/V2SettingsShell';

export const TermsAndConditionSettingsV2 = () => {
  const { langText } = useContext(AppContext);
  const termsText = langText?.settings?.terms;
  return (
    <V2SettingsShell title={termsText?.title || 'Terms and Conditions'}>
      <Card sx={{ p: { xs: 2.5, md: 4 } }}>
        <Box sx={{ '& *': { color: 'text.primary' } }}>
          <TermsAndCondition />
        </Box>
      </Card>
    </V2SettingsShell>
  );
};
